import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";

export function useDocumentPermissions() {
  const currentUserService = inject("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  const canCheckDocuments = permissions.includes("filemanager.check_document");
  const canViewCheckCheckbox = permissions.includes("utilities.can_view_check_documents_button");
  const canApproveDocuments = permissions.includes("filemanager.change_documentapproval");
  const canViewApprovalCheckbox = permissions.includes(
    "utilities.can_view_approve_documents_button"
  );

  return {
    canCheckDocuments,
    canViewCheckCheckbox,
    canApproveDocuments,
    canViewApprovalCheckbox,
  };
}
